import type { I18nLocale } from '#/i18n/types/I18nLocale';

type Args = {
  sanitizedValue: string;
  decimalSeparator: string;
  maxDecimalPlaces: number | undefined;
  allowDecimal: boolean;
  locale: I18nLocale;
};

export function currencyInputDelimiterFormat({
  sanitizedValue,
  decimalSeparator,
  maxDecimalPlaces,
  allowDecimal,
  locale,
}: Args): string {
  // input is cleared
  if (!sanitizedValue) return '';

  if (!allowDecimal) {
    return parseInt(sanitizedValue, 10).toLocaleString(locale);
  }

  // e.g. typed "."
  if (sanitizedValue === decimalSeparator) return decimalSeparator;

  const parts = sanitizedValue.split(decimalSeparator);

  // If there's no decimal separator, return the integer part.
  if (parts.length === 1) {
    const [integerPart] = parts;
    return parseInt(integerPart, 10).toLocaleString(locale);
  }

  // If there's a decimal separator, format the integer part and leave the fraction as-is.
  const integerPart = parseInt(parts[0] || '0', 10).toLocaleString(locale);
  const fractionPart = parts[1].slice(0, maxDecimalPlaces);
  return `${integerPart}${decimalSeparator}${fractionPart}`;
}
